import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ManifestController, SetNextNode } from '@flexus/core';
import { Observable } from 'rxjs';

@Component({
	selector: 'flx-success-tick',
	templateUrl: './success-tick.component.html',
	styleUrls: ['./success-tick.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FLXSuccessTickComponent implements AfterViewInit {
	constructor(private router: Router, private _control: ManifestController<unknown>) {}
	@Input() autoClose = true;
	@Input() copyText$: Observable<unknown>;
	@Input() copyTextHeading = 'Claim Number';
	@Input() heading = 'The submission was successful. You can return to the workflow.';
	@Input() headingcolour: 'success' | 'danger' | 'alert' | 'secondary' = 'success';
	@Input() altNextNode: string;
	@Input() showContinueButton = false;
	@Input() continueText = 'Continue';
	@Input() continueColor: string = 'primary';

	ngAfterViewInit() {
		if (this.autoClose) {
			setTimeout(() => {
				if (this.altNextNode) {
					this.altDirect();
				} else {
					this.redirect();
				}
			}, 3000);
		}
	}
	redirect() {
		// Allows consumers with a deactivate-guard to bypass warning modals for explicit success redirects
		this.router.navigate(['/workflow'], { state: { flxBypassDeactivateGuard: true } });
	}

	onContinue() {
		if (this.altNextNode) {
			this.altDirect();
		} else {
			this.redirect();
		}
	}
	altDirect() {
		this._control.dispatch(new SetNextNode(this.altNextNode));
	}
}
